import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { ColumnDef } from "../../models/orders/order-list-model";
import { useState, Suspense } from "react";
import posService from "../../services/pos/pos.service";
import AppLoading from "../app-loading/app-loading";
import SummaryTableInDetailsDatatable from "./pos-movement-summary-indetaildatatable";
import SummaryTableSalesInDetailsDatatable from "./pos-movement-summary-salesindetaildatatable";
 
 
interface Summarylog {
  productName: string;
  inwardQuantity: number;
  outwardQuantity: number;
  adjustQuantity: number;
  salesQuantity: number;
  createdDate: any;
  productId: number;
}
 
interface SummaryTableProps {
  data: Summarylog[];
  loading: boolean;
  posId: number;
  startDate: any;
  endDate: any;
}
 
const SummaryTable = ({ data, loading, posId, startDate, endDate }: SummaryTableProps) => {
 
  const [visible, setVisible] = useState<boolean>(false);
  const [inDetails, setInDetails] = useState<any[]>([]);
  const [dailogHeader, setDailogHeader] = useState<string>("");
  const [type, setType] = useState<string>("");
 
  function handelInwardClick() {
    setVisible(false)
  }
 
  const handelInwardQuantityClick = async (quantity: number, productId: number) => {
 
    if (quantity > 0) {
      setType("Inward");
      loading = true;
      setVisible(true);
      var filter = {
        "posId": posId,
        "startDate": startDate,
        "endDate": endDate,
        "productId": productId,
        "typeName": "Inward"
      }
      const response = await posService.GetPOSMovementsInwardDetails(filter)
      if (response.length > 0) {
        setInDetails(response);
        setDailogHeader("Inward Details for " + response[0].posName + "- " + data.filter(x => x.productId === productId)[0].productName);
        loading = false;
      }
    }
    else {
      setInDetails([]);
    }
  }
 
  const handelOutwardQuantityClick = async (quantity: number, productId: number) => {
 
    if (quantity > 0) {
      setType("Outward");
      loading = true;
      setVisible(true);
      var filter = {
        "posId": posId,
        "startDate": startDate,
        "endDate": endDate,
        "productId": productId,
        "typeName": "Outward"
      }
      const response = await posService.GetPOSMovementsInwardDetails(filter)
      if (response.length > 0) {
        setInDetails(response);
        setDailogHeader("Outward Details for " + response[0].posName + "- " + data.filter(x => x.productId === productId)[0].productName);
        loading = false;
      }
    }
    else {
      setInDetails([]);
    }
  }
 
  const handelSalesQuantityClick = async (quantity: number, productId: number) => {
    if (quantity > 0) {
      setType("Sales");
      loading = true;
      setVisible(true);
      var filter = {
        "posId": posId,
        "startDate": startDate,
        "endDate": endDate,
        "productId": productId,
      }
      const response = await posService.GetPOSMovementsSalesInwardDetails(filter)
      if (response.length > 0) {
        setInDetails(response);
        setDailogHeader("Sales Details for " + response[0].posName + "- " + data.filter(x => x.productId === productId)[0].productName);
        loading = false;
      }
    }
    else {
      setInDetails([]);
    }
  }
 
  const columns: ColumnDef[] = [
    {
      field: "productName",
      header: "Product",
      style: { minWidth: "9rem" },
      sortable: true,
    },
    {
      field: "inwardQuantity",
      header: "Inward",
      style: { minWidth: "7rem" },
      sortable: true,
      cell: (row: any) => (
        row.inwardQuantity > 0 ?
          <span
            style={{ color: "darkcyan", fontWeight: "bolder", cursor: "pointer" }}
            onClick={() => handelInwardQuantityClick(row.inwardQuantity, row.productId)}
          >
            {row.inwardQuantity}
          </span> : <span>{row.inwardQuantity}</span>
      ),
    },
    {
      field: "outwardQuantity",
      header: "Outward",
      style: { minWidth: "9rem" },
      sortable: true,
      cell: (row: any) => (
        row.outwardQuantity > 0 ?
          <span
            style={{ color: "darkcyan", fontWeight: "bolder", cursor: "pointer" }}
            onClick={() => handelOutwardQuantityClick(row.outwardQuantity, row.productId)}
          >
            {row.outwardQuantity}
          </span> : <span>{row.outwardQuantity}</span>
      ),
    },
    {
      field: "adjustQuantity",
      header: "Adjust",
      style: { minWidth: "9rem" },
      sortable: true,
    },
    {
      field: "salesQuantity",
      header: "Sales",
      style: { minWidth: "9rem" },
      sortable: true,
      cell: (row: any) => (
        row.salesQuantity > 0 ?
          <span
            style={{ color: "darkcyan", fontWeight: "bolder", cursor: "pointer" }}
            onClick={() => handelSalesQuantityClick(row.salesQuantity, row.productId)}
          >
            {row.salesQuantity}
          </span> : <span>{row.salesQuantity}</span>
      ),
    },
  ];
 
  return (
 
    <div className="col-12">
      <Suspense fallback={<AppLoading />}>
        <DataTable
          value={data}
          loading={loading}
          paginator
          rows={10}
          rowsPerPageOptions={[5, 10, 20, 50]}
          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
        >
          {columns.map((col, i) => (
            <Column
              key={i}
              field={col.field}
              header={col.header}
              sortable={col.sortable}
              style={col.style}
              body={col.cell}
            />
          ))}
        </DataTable>
        <Dialog visible={visible} style={{ width: "70vw" }} header={dailogHeader} onHide={handelInwardClick}>
          {inDetails.length > 0 ?
            type === "Inward" || type === "Outward" ?
            <SummaryTableInDetailsDatatable data={inDetails} type={type} /> :
            <SummaryTableSalesInDetailsDatatable data={inDetails}/>  : ""
          }
        </Dialog>
        {loading && <AppLoading />}
      </Suspense>
    </div>
 
  );
 
}
 
export default SummaryTable;